import { render, staticRenderFns } from "./FaqPlan.vue?vue&type=template&id=0aa8bde1&"
import script from "./FaqPlan.vue?vue&type=script&lang=js&"
export * from "./FaqPlan.vue?vue&type=script&lang=js&"
import style0 from "./FaqPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports